/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StopIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAdUlEQVR4nGNgGAWkgNDQUDa/gPBOX//wZ34BEf9Jwb4B4U/9AiI6QGbgtACkgFSD/TBxB04LyHG5Hzr2j3iOzwf/qYEZRi3wGw0iv9FUhAuMZjQ/QkUFtMilNBU9oWlx7esf0U6gwonoIMcnvsRUOKOAAQsAAJwicdyeNWeAAAAAAElFTkSuQmCC)
 */
export const StopIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        fill={typeof color === 'string' ? color : color.css}
        rx="3"
        className={colorClass}
      />
    </svg>
  );
};
